// @ts-nocheck
import React from "react";
import { formatDateTimeLabel } from "../forecastUtil";

// A simple component to show the current time label on mobile graphs
const GraphMobileTimeLabel = ({ isMobile, timeZone, className = "" }) => {
  if (!isMobile) return null;

  return (
    <div className={`text-[11px] font-Inter text-gray-700 mb-1 ml-1 ${className}`}>
      {formatDateTimeLabel(new Date(), timeZone)}
    </div>
  );
};

export default GraphMobileTimeLabel;
